export const projectTitle = process.env.REACT_APP_FTL_PROJECT_TITLE || "Admin Panel"
